export default __webpack_public_path__ + "static/Floorplan_2BR_v1-cdc055e31427f5cb16b7bd242d83591d.svg";